var _defs, _path, _polygon, _rect, _rect2, _circle, _circle2, _circle3, _rect3, _polyline, _line, _polyline2, _line2, _polyline3, _line3, _polyline4, _line4, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path2, _path3, _path4, _path5, _path6, _path7, _g, _polygon2, _path8, _rect13, _g2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g3, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _circle4, _path25, _path26, _g4, _path27, _path28, _path29, _path30, _path31, _rect14, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "621cd0f7-cd48-4ca5-9ab8-51101f02d17b",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 934,
    height: 618.51,
    viewBox: "0 0 934 618.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "4bd29515-a36b-434d-8cb2-ef58db952749",
    x1: 405.94,
    y1: 486.08,
    x2: 405.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "75668aed-0dd6-4be1-8f61-e9e9607e27cc",
    x1: 882.19,
    y1: 420.35,
    x2: 882.19,
    y2: 420.11,
    xlinkHref: "#4bd29515-a36b-434d-8cb2-ef58db952749"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7a0f4aa-52a5-4948-9edf-debdb0daa9d7",
    x1: 678.75,
    y1: 242.6,
    x2: 678.75,
    y2: 70.7,
    xlinkHref: "#4bd29515-a36b-434d-8cb2-ef58db952749"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c8614dc2-cdff-4ba8-8237-275c967500fc",
    x1: 811.07,
    y1: 759.23,
    x2: 811.07,
    y2: 366.46,
    xlinkHref: "#4bd29515-a36b-434d-8cb2-ef58db952749"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "08b724b8-eaea-4fee-acb6-2f8c8e2e28b7",
    x1: 784.26,
    y1: 349.97,
    x2: 784.68,
    y2: 349.97,
    xlinkHref: "#4bd29515-a36b-434d-8cb2-ef58db952749"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "399cbcc8-6c11-46ae-9bf3-749ff25996fe",
    x1: 784.59,
    y1: 350.3,
    x2: 785,
    y2: 350.3,
    xlinkHref: "#4bd29515-a36b-434d-8cb2-ef58db952749"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b33caef3-b1e0-4555-a46c-2bbed8f5044a",
    x1: 784.59,
    y1: 349.97,
    x2: 785,
    y2: 349.97,
    xlinkHref: "#4bd29515-a36b-434d-8cb2-ef58db952749"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "image upload") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234,543.27c-22.93,1-47.41,5.77-63.38,22.26C144,593,155.14,642.93,185.78,665.86s73,23.64,110.08,14.12c19.93-5.12,40.45-12.94,60.49-8.24,25.25,5.92,42.81,30.26,67.84,37.07C457.82,718,490,693.3,522.4,680.35c55.3-22.13,123.32-7.6,164.76,35.19,11.57,11.94,21.48,26.06,35.93,34.27,14.61,8.31,32.11,9.56,48.91,9.43,50.47-.4,100.16-11.56,149.39-22.66,31.26-7,63.1-14.32,90.74-30.54s50.92-43.14,54.53-75c.63-5.55.61-11.41-1.84-16.44-4.05-8.33-13.52-12.27-22.19-15.52-25.76-9.65-54.71-19.28-80-8.36-6.63,2.87-12.78,7.1-19.86,8.56-20.21,4.15-36.72-14.66-52.46-28C841.59,530,770.59,533.77,708.41,519,636,501.86,559.12,487.84,483.84,498.75c-37.88,5.49-67,31.21-103.19,41.15C332.94,553,282.56,541.2,234,543.27Z",
    transform: "translate(-133 -140.75)",
    fill: "#00b27d",
    opacity: 0.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "127.8 0 127.8 26.92 127.8 486.08 684.08 486.08 684.08 26.92 684.08 0 127.8 0",
    fill: "url(#4bd29515-a36b-434d-8cb2-ef58db952749)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 131.36,
    width: 549.17,
    height: 15.55,
    fill: "#535461"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 131.36,
    y: 15.11,
    width: 549.17,
    height: 460.44,
    fill: "#ededf4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 141.58,
    cy: 7.55,
    r: 2.67,
    fill: "#fa595f"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.57,
    cy: 7.55,
    r: 2.67,
    fill: "#ffc74c"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.57,
    cy: 7.55,
    r: 2.67,
    fill: "#85d459"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 195.34,
    y: 42.11,
    width: 421.21,
    height: 165.29,
    fill: "#fff"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "616.55 201.4 616.55 207.4 610.55 207.4",
    fill: "none",
    stroke: "#00b27d",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 598.86,
    y1: 207.4,
    x2: 207.18,
    y2: 207.4,
    fill: "none",
    stroke: "#00b27d",
    strokeMiterlimit: 10,
    strokeDasharray: "11.69 11.69"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "201.34 207.4 195.34 207.4 195.34 201.4",
    fill: "none",
    stroke: "#00b27d",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 195.34,
    y1: 189.61,
    x2: 195.34,
    y2: 54.01,
    fill: "none",
    stroke: "#00b27d",
    strokeMiterlimit: 10,
    strokeDasharray: "11.79 11.79"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "195.34 48.11 195.34 42.11 201.34 42.11",
    fill: "none",
    stroke: "#00b27d",
    strokeMiterlimit: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 213.03,
    y1: 42.11,
    x2: 604.7,
    y2: 42.11,
    fill: "none",
    stroke: "#00b27d",
    strokeMiterlimit: 10,
    strokeDasharray: "11.69 11.69"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "610.55 42.11 616.55 42.11 616.55 48.11",
    fill: "none",
    stroke: "#00b27d",
    strokeMiterlimit: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 616.55,
    y1: 59.9,
    x2: 616.55,
    y2: 195.5,
    fill: "none",
    stroke: "#00b27d",
    strokeMiterlimit: 10,
    strokeDasharray: "11.79 11.79"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 298.42,
    y: 230.5,
    width: 215.05,
    height: 8.89,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 190.67,
    y: 313.24,
    width: 215.05,
    height: 8.89,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 190.67,
    y: 332.79,
    width: 215.05,
    height: 8.89,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 190.67,
    y: 352.34,
    width: 215.05,
    height: 8.89,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 190.67,
    y: 371.89,
    width: 215.05,
    height: 8.89,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 190.67,
    y: 391.44,
    width: 215.05,
    height: 8.89,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 190.67,
    y: 410.99,
    width: 215.05,
    height: 8.89,
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 190.67,
    y: 430.54,
    width: 215.05,
    height: 8.89,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 359.73,
    y: 248.27,
    width: 92.42,
    height: 8.89,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M538.94,309.93a44.43,44.43,0,1,0-44.43-44.43A44.42,44.42,0,0,0,538.94,309.93Zm0-80.26a35.83,35.83,0,1,1-35.83,35.83A35.82,35.82,0,0,1,538.94,229.67Zm3.58,58.76h-7.17a2.16,2.16,0,0,1-2.15-2.15V265.5h-12a2.15,2.15,0,0,1-1.52-3.67l17.74-17.74a2.15,2.15,0,0,1,3,0l17.74,17.74a2.15,2.15,0,0,1-1.52,3.67h-12v20.78A2.16,2.16,0,0,1,542.53,288.43Z",
    transform: "translate(-133 -140.75)",
    fill: "#00b27d",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M281.37,494c11,40.23-35.93,154.83-35.93,154.83s-98.74-74.75-109.74-115A75.51,75.51,0,1,1,281.37,494Z",
    transform: "translate(-133 -140.75)",
    fill: "#00b27d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M281.37,494c11,40.23-35.93,154.83-35.93,154.83s-98.74-74.75-109.74-115A75.51,75.51,0,1,1,281.37,494Z",
    transform: "translate(-133 -140.75)",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M189,441.35s61.47,92.79,56.83,207.75",
    transform: "translate(-133 -140.75)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M297.06,567.56s-55.74-30.32-48.68,81.6c0,0,46.5-1.66,63-39.59A32.89,32.89,0,0,0,297.88,568Z",
    transform: "translate(-133 -140.75)",
    fill: "#00b27d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M298,567.75s-7.2,58.1-49.59,81.41",
    transform: "translate(-133 -140.75)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M882.1,420.35c.12-.15.18-.25.18-.25Z",
    transform: "translate(-133 -140.75)",
    fill: "url(#75668aed-0dd6-4be1-8f61-e9e9607e27cc)"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "465.48 70.7 465.48 242.6 510.93 242.6 534.97 242.6 547.27 242.6 558.47 242.6 574.67 242.6 578.25 242.6 612.96 242.6 625.71 242.6 635.28 242.6 641.53 242.6 641.71 242.6 642.03 242.6 646.62 242.6 656.18 242.6 659.9 242.6 660.3 242.6 660.39 242.6 660.62 242.6 661.11 242.6 668.94 242.6 669.45 242.6 669.57 242.6 684.74 242.6 685.22 242.6 685.82 242.6 703.66 242.6 708.98 242.6 721.73 242.6 749.73 242.6 781.61 242.6 781.61 242.6 787.68 242.6 788.8 242.6 789.85 242.6 789.85 242.6 796.27 242.6 797.2 242.6 809.43 242.6 825.54 242.6 833.33 242.6 849.28 242.6 892.02 242.6 892.02 70.7 465.48 70.7",
    fill: "url(#e7a0f4aa-52a5-4948-9edf-debdb0daa9d7)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M907.72,432.81a21.23,21.23,0,0,0-2-8.89l-12.43-29.75s-.45.62-1.22,1.47c-.91-7.59-4.37-22.07-17.43-23-17.76-1.29-24,7.76-20.42,8.62s18.65,6.9,18.65,6.9l7,11.49c-.13-.09-.25-.18-.38-.28l.26,1.05-.26-.19.26,1.05-.26-.19,6.76,27.9L872.45,441.6s-13.32,6.47-20,6a24,24,0,0,0-3.79.08l.5-.33,4.4-2.92c3.4-2.25,6.95-4.68,8.65-8.32l0-.06c.15-.26.29-.53.42-.8,1.79-3.83,1.17-8.24,1.26-12.44a62.84,62.84,0,0,0,.12-7.67,22.12,22.12,0,0,0-2.07-7,25.75,25.75,0,0,0-9.29-11,18.88,18.88,0,0,0-14.17-2.67,9.82,9.82,0,0,1-2.41.42c-1.58,0-2.94-1-4.39-1.61a9.19,9.19,0,0,0-10.54,3c-1,1.32-1.51,2.89-2.52,4.17-1.5,1.91-3.93,3.11-4.94,5.3l-.1.24a5.43,5.43,0,0,0-.35.62c-1,2.16-.34,4.67-.55,7a19,19,0,0,1-2,6,5,5,0,0,0,1.19-.59,20.56,20.56,0,0,0-.29,16.44,36.51,36.51,0,0,1-3.92,12.16l-.13.12-.06,0-.36.28,0,0-.4.27q.69-1.07,1.59-2.23c-.88,1.06-5,5.11-13.58.19-9.77-5.6-32.85-5.6-32.85-5.6l-23-10.31c.42-7.26,2.37-35.61,7-37.12a14.21,14.21,0,0,1-1.37.45l0,0,.11-.18.11-.16.11-.15.12-.14.11-.12.12-.12.11-.09.13-.1.11-.07.14-.07.18-.08s-.48.19-1.26.41l.41-.68a2,2,0,0,1,.85-.6s-.23.09-.61.22l5.94-9.7s15.09-6,18.65-6.9-2.66-9.92-20.42-8.62c-12,.88-15.9,13.2-17.16,21.08-.05-.13-.11-.25-.16-.39L714.41,433s0,.21.11.58l-.11.28s0,.21.11.58l-.11.28s1.33,9.92,11.1,13.8l36.85,22s16,9.48,16,33.2,3.11,61.22,3.11,61.22.61.36,1.73,1c-2.78,7.75-8.15,21.59-11.95,24-5.33,3.45-18.65,33.2-18.65,33.2H753l-.39.86s.74,0,2,0l-10.87,21.11s-3.55,9.48,0,15.52,2.66,18.54,2.66,18.54,7.1,20.26,12.87,29.75c2.93,4.82,3.46,10.74,3.26,15.41l-12.14,19.94s-5.77,5.17-10.21,4.31c-2.08-.4-4.16,2.22-3.91,4.86v.23q0,.11,0,.21s0,.06,0,.09,0,.16,0,.23v.07c0,.1,0,.2,0,.3v0q0,.13.05.27l0,.09.06.21,0,.1.07.21,0,.09.11.25,0,0,.16.28,0,.07.14.21.07.09.14.18.08.09.17.19.07.07.27.25,0,0,.26.21.1.07.22.15.12.08.24.14.13.07.31.16.08,0,.42.18.12,0,.34.12.17.05.33.1.18.05.37.09.17,0,.57.11h0l.56.08.2,0,.44,0,.24,0,.45,0h1.93l.61,0,.29,0,.57,0,.31,0,.62-.06.29,0,.94-.12c18.2-2.59,39.51-12.07,39.51-12.07v0h0v0h0a35.85,35.85,0,0,0,.15-3.8c.06-5.17-.82-15.45-8.37-18.32h-.39c-1.86-5.74-3.37-13-2.05-19.18,2.66-12.5-7.55-35.34-7.55-43.11,0-1.72-2.22-5.6,2.22-11.21,2.07-2.61,6.83-7.09,11.28-12a20.27,20.27,0,0,1-1.52,2,4,4,0,0,0,.59.12c-.19.24-.38.49-.59.74,0,0,5.91,1.91,10.69-6.53.29-.51.58-1.07.86-1.66,4.88-10.35,17.31-25,23.53-24.14,5.73.79,18.64,11.86,21.31,19.66a9.44,9.44,0,0,1,.44,1.9c.89,7.76,12.43,8.62,12.43,8.62l-.7-.94.44.05a128.53,128.53,0,0,1,6.93,12.1c3.55,7.76,3.11,12.93,3.11,12.93-9.77,19.83-6.22,31.9-6.22,44a53.68,53.68,0,0,1-1,9.77c-6.33,3.91-7.45,21.27-7.45,21.27l.06.07h0v.06l0,.23v.5S860,753.29,877.33,755l.81.07.27,0,.51,0h.3l.45,0h2.38l.35,0,.28,0,.34,0,.27,0,.33,0,.25,0,.31,0,.24,0,.3,0,.23,0,.29-.06.22,0,.28-.06.2-.05.27-.07.18-.05.26-.08.17-.06.25-.09.16-.06.24-.1.14-.06.24-.1.13-.06.23-.11.12-.06.22-.12.1-.06.21-.13.09-.06.2-.14.08-.06.19-.15.07-.05.18-.16.06-.05.18-.17,0,0,.17-.18,0,0,.16-.19,0,0,.15-.2,0,0,.13-.21v0l.12-.22h0l.11-.23h0a3.77,3.77,0,0,0,.32-2,3.68,3.68,0,0,0-3.67-4.11c-5.33,0-8-6-8-6L870,717.29l-.23-.06c.4-2.19.75-4.32.9-5.76.27-2.67,5.66-15.92,9.72-25.62a60.51,60.51,0,0,0,4.53-18.21,52.08,52.08,0,0,1,1.73-9.62,20.32,20.32,0,0,0-.33-12,45.42,45.42,0,0,1-2.14-10.26c-.47-5.33-2.66-10.72-4.82-14.9l.19,0-.29-.94.29.07s-8.88-28.88-13.32-32.76c-3.22-2.81-10.63-16-14.63-24.25a39.71,39.71,0,0,0,2.2-3.34l-.13-.65.13-.21-.13-.65.13-.21s-4.51-22.36-4.68-38.42c.05-5.16.62-9.51,2-12,0,0,1.78-27.16,16-32.33L904,442.46s3.94-2.4,3.75-8.79C907.73,433.39,907.73,433.11,907.72,432.81ZM806.8,449.21l0,0,.4-.61Zm31.47,1s-.07.41-.25,1.09a14.46,14.46,0,0,1-1.32-3.14,22.05,22.05,0,0,0,3.43-1.06,5.92,5.92,0,0,0,2.56,1.7A41.63,41.63,0,0,0,838.27,450.22Zm8.9,181.61c1,1.49,2,3.08,3,4.7C849.22,635.15,848.06,633.41,847.17,631.83Z",
    transform: "translate(-133 -140.75)",
    fill: "url(#c8614dc2-cdff-4ba8-8237-275c967500fc)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 467.7,
    y: 73.31,
    width: 421.21,
    height: 165.29,
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "846.7 171.57 846.7 238.6 512.58 238.6 512.58 136.94 523.07 136.94 523.07 111.04 562.96 111.04 562.96 136.94 573.81 136.94 573.81 214.6 587.8 214.6 587.8 189.41 604.6 189.41 604.6 214.6 618.59 214.6 618.59 171.57 619.29 171.57 619.29 149.18 632.59 149.18 632.59 171.57 663.37 171.57 663.37 205.16 680.51 205.16 680.51 194.66 691.02 194.66 691.02 205.16 708.16 205.16 708.16 105.79 730.55 105.79 730.55 90.05 734.4 90.05 734.4 105.79 740.69 105.79 740.69 136.94 751.89 136.94 751.89 111.04 761.33 111.04 761.33 84.45 780.93 84.45 780.93 111.04 790.37 111.04 790.37 136.94 801.92 136.94 801.92 171.57 817.66 171.57 817.66 149.18 830.96 149.18 830.96 171.57 846.7 171.57",
    fill: "#00b27d",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.23,
    y: 144.98,
    width: 14.69,
    height: 8.4,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.11,
    y: 285.73,
    width: 14.69,
    height: 8.4,
    transform: "translate(1251.92 439.1) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.23,
    y: 161.42,
    width: 14.69,
    height: 8.4,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.11,
    y: 302.17,
    width: 14.69,
    height: 8.4,
    transform: "translate(1251.92 471.99) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.23,
    y: 177.87,
    width: 14.69,
    height: 8.4,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.11,
    y: 318.62,
    width: 14.69,
    height: 8.4,
    transform: "translate(1251.92 504.88) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.23,
    y: 194.31,
    width: 14.69,
    height: 8.4,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.11,
    y: 335.06,
    width: 14.69,
    height: 8.4,
    transform: "translate(1251.92 537.77) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.23,
    y: 210.76,
    width: 14.69,
    height: 8.4,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.11,
    y: 351.5,
    width: 14.69,
    height: 8.4,
    transform: "translate(1251.92 570.66) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.23,
    y: 227.2,
    width: 14.69,
    height: 8.4,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.11,
    y: 367.95,
    width: 14.69,
    height: 8.4,
    transform: "translate(1251.92 603.54) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579.05,
    y: 223,
    width: 34.29,
    height: 4.2,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579.05,
    y: 229.3,
    width: 34.29,
    height: 4.2,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579.06,
    y: 235.59,
    width: 34.28,
    height: 3,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.62,
    y: 225.1,
    width: 34.29,
    height: 4.2,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.62,
    y: 231.4,
    width: 34.29,
    height: 4.2,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.62,
    y: 237.7,
    width: 34.28,
    height: 0.9,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.94,
    y: 179.62,
    width: 9.45,
    height: 12.25,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 779.58,
    y: 320.36,
    width: 9.45,
    height: 12.25,
    transform: "translate(1435.6 512.23) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.94,
    y: 199.21,
    width: 9.45,
    height: 12.25,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 779.58,
    y: 339.96,
    width: 9.45,
    height: 12.25,
    transform: "translate(1435.6 551.41) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.94,
    y: 218.8,
    width: 9.45,
    height: 12.25,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 779.58,
    y: 359.55,
    width: 9.45,
    height: 12.25,
    transform: "translate(1435.6 590.6) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.93,
    y: 238.39,
    width: 9.45,
    height: 0.2,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.58,
    y: 238.39,
    width: 9.45,
    height: 0.2,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 708.16,
    y: 113.84,
    width: 12.6,
    height: 16.09,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 708.16,
    y: 136.93,
    width: 12.6,
    height: 16.09,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 708.16,
    y: 160.02,
    width: 12.6,
    height: 16.09,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 708.16,
    y: 183.12,
    width: 12.6,
    height: 16.09,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 708.16,
    y: 206.21,
    width: 12.6,
    height: 16.09,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 708.16,
    y: 229.3,
    width: 12.59,
    height: 9.3,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 747.87,
    y: 146.73,
    width: 46.88,
    height: 13.64,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.04,
    y: 176.12,
    width: 46.88,
    height: 13.64,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.22,
    y: 205.51,
    width: 46.88,
    height: 13.64,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "788.02 238.6 794.35 238.6 795.27 238.6 795.27 237.06 795.27 235.29 795.27 234.9 795.15 234.9 788.67 234.9 785.71 234.9 748.39 234.9 748.39 238.6 779.88 238.6 785.88 238.6 786.98 238.6 788.02 238.6",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.08,
    y: 118.39,
    width: 6.3,
    height: 13.3,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 830.96,
    y: 179.62,
    width: 15.74,
    height: 20.29,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 830.96,
    y: 209.01,
    width: 15.74,
    height: 20.29,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 830.96,
    y: 238.39,
    width: 15.75,
    height: 0.2,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.18,241.88h-2.41a1.69,1.69,0,1,0,0-3.37h-19.5a1.69,1.69,0,1,0,0,3.37h2.41a1.69,1.69,0,1,0,0,3.37h-3.37a1.69,1.69,0,1,0,0,3.37h19.5a1.69,1.69,0,0,0,0-3.37h3.37a1.69,1.69,0,0,0,0-3.37Z",
    transform: "translate(-133 -140.75)",
    fill: "#252223",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.25,284.22h-2.41a1.69,1.69,0,0,0,0-3.37h-19.5a1.69,1.69,0,0,0,0,3.37h2.41a1.69,1.69,0,1,0,0,3.37h-3.37a1.69,1.69,0,0,0,0,3.37h19.5a1.69,1.69,0,0,0,0-3.37h3.37a1.69,1.69,0,1,0,0-3.37Z",
    transform: "translate(-133 -140.75)",
    fill: "#252223",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.85,228.94h-2.41a1.69,1.69,0,0,0,0-3.37h-19.5a1.69,1.69,0,1,0,0,3.37h2.41a1.69,1.69,0,1,0,0,3.37H948a1.69,1.69,0,1,0,0,3.37h19.5a1.69,1.69,0,0,0,0-3.37h3.37a1.69,1.69,0,0,0,0-3.37Z",
    transform: "translate(-133 -140.75)",
    fill: "#252223",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.68,349.82l-.42.31A1.77,1.77,0,0,0,784.68,349.82Z",
    transform: "translate(-133 -140.75)",
    fill: "url(#08b724b8-eaea-4fee-acb6-2f8c8e2e28b7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785,350.15l-.42.31A1.77,1.77,0,0,0,785,350.15Z",
    transform: "translate(-133 -140.75)",
    fill: "url(#399cbcc8-6c11-46ae-9bf3-749ff25996fe)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785,349.82l-.42.31A1.77,1.77,0,0,0,785,349.82Z",
    transform: "translate(-133 -140.75)",
    fill: "url(#b33caef3-b1e0-4555-a46c-2bbed8f5044a)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 767.29,
    cy: 343.26,
    rx: 0.48,
    ry: 0.64,
    transform: "translate(-205.94 226.61) rotate(-25.74)",
    fill: "#f2f2f2"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M759.32,618.32l-12.75,25.5s-3.4,9.35,0,15.3,2.55,18.28,2.55,18.28,6.8,20,12.33,29.33,2.13,23,2.13,23l22.1,2.55s-8.5-16.58-6-28.91-7.23-34.84-7.23-42.51c0-1.7-2.13-5.53,2.13-11.05s20.4-19.55,20-27.63Z",
    transform: "translate(-133 -140.75)",
    fill: "#f7bbc3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M872,612.37s8.16,11.3,9.11,22.3a46,46,0,0,0,2,10.11,20.6,20.6,0,0,1,.32,11.8,52.73,52.73,0,0,0-1.66,9.49,61.12,61.12,0,0,1-4.34,18c-3.89,9.57-9,22.63-9.3,25.26-.43,4.25-2.55,14.45-2.55,14.45l-17,6.38s5.1-12.33,5.1-24.23-3.4-23.8,6-43.36c0,0,.43-5.1-3-12.75s-16.58-27.63-16.58-27.63Z",
    transform: "translate(-133 -140.75)",
    fill: "#f7bbc3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M844.48,627.53c-1.4,1.52,5.81,11.2,5.81,11.2s-11.05-.85-11.9-8.5a9.54,9.54,0,0,0-.43-1.87c-2.56-7.69-14.92-18.6-20.4-19.38-6-.85-17.85,13.6-22.53,23.8-.27.59-.54,1.13-.82,1.64-4.57,8.32-10.23,6.44-10.23,6.44,3-3.7,3.62-6.63,2.68-9-3.72-9.17-31.58-8.9-31.58-8.9s12.75-29.33,17.85-32.73,13.18-28.91,13.18-28.91,60.79-6.8,61.21-3.83,12.33,26.36,16.58,30.18S876.65,620,876.65,620c-14.45-4.25-30.39,6.16-32.09,7.44Z",
    transform: "translate(-133 -140.75)",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M844.48,626.68c-1.4,1.52,5.81,11.2,5.81,11.2s-11.05-.85-11.9-8.5a9.54,9.54,0,0,0-.43-1.87c-2.56-7.69-14.92-18.6-20.4-19.38-6-.85-17.85,13.6-22.53,23.8-.27.59-.54,1.13-.82,1.64C789.64,641.89,784,640,784,640c3-3.7,3.62-6.63,2.68-9-3.72-9.17-31.58-8.9-31.58-8.9s12.75-29.33,17.85-32.73,13.18-28.91,13.18-28.91,60.79-6.8,61.21-3.83,12.33,26.36,16.58,30.18,12.75,32.31,12.75,32.31c-14.45-4.25-30.39,6.16-32.09,7.44Z",
    transform: "translate(-133 -140.75)",
    fill: "#8499f0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M764.64,721.83l-11.69,19.77s-5.53,5.1-9.78,4.25-8.5,11.9,8.93,9.35,37.83-11.9,37.83-11.9,1.91-17.22-7.86-21Z",
    transform: "translate(-133 -140.75)",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M867.51,715l9.14,21.47s2.55,6,7.65,6,6.8,10.63-9.78,8.93-28.91-14.88-28.91-14.88,1.28-20.4,8.93-21.68A32.61,32.61,0,0,1,867.51,715Z",
    transform: "translate(-133 -140.75)",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M764.64,722.68l-11.69,19.77s-5.53,5.1-9.78,4.25-8.5,11.9,8.93,9.35,37.83-11.9,37.83-11.9,1.91-17.22-7.86-21Z",
    transform: "translate(-133 -140.75)",
    fill: "#b77983"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M867.51,715.88l9.14,21.47s2.55,6,7.65,6,6.8,10.63-9.78,8.93-28.91-14.88-28.91-14.88,1.28-20.4,8.93-21.68A32.61,32.61,0,0,1,867.51,715.88Z",
    transform: "translate(-133 -140.75)",
    fill: "#b77983"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M845.19,556.68c.43,3,12.33,26.36,16.58,30.18,3.9,3.51,11.39,27.82,12.59,31.76.77.15,1.53.32,2.29.54,0,0-8.5-28.48-12.75-32.31s-16.15-27.21-16.58-30.18c-.08-.59-2.57-.8-6.48-.74C843.5,556,845.12,556.21,845.19,556.68Z",
    transform: "translate(-133 -140.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.43,608.12c-6-.85-17.85,13.6-22.53,23.8-.27.59-.54,1.13-.82,1.64-2.64,4.8-5.63,6.2-7.7,6.53,1.37.25,6,.46,9.83-6.53.28-.51.55-1.05.82-1.64,4.29-9.36,14.65-22.28,20.93-23.7Z",
    transform: "translate(-133 -140.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.48,626.68l.07-.07c1.37-1,12-8,23.65-8.43-12.45-.43-24.32,7.34-25.78,8.43l-.07.07c-1.23,1.34,4.19,9,5.52,10.8a19.37,19.37,0,0,0,2.41.39S843.08,628.19,844.48,626.68Z",
    transform: "translate(-133 -140.75)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M735.09,396.43s0-25.93,17-27.21,23,7.65,19.55,8.5-17.85,6.8-17.85,6.8l-9.35,15.73Z",
    transform: "translate(-133 -140.75)",
    fill: "#f7bbc3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M889,402.38s0-25.93-17-27.21-23,7.65-19.55,8.5,17.85,6.8,17.85,6.8l9.35,15.73Z",
    transform: "translate(-133 -140.75)",
    fill: "#f7bbc3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M812,429.16s1.28,17-9.35,26.78S827.34,478,827.34,478l15.73-18.7s-12.75-7.65-6-20.83Z",
    transform: "translate(-133 -140.75)",
    fill: "#f7bbc3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M808.63,449.14s-3.83,6-13.18.43S764,444,764,444l-22.1-10.2s1.7-36.56,6.8-38.26c0,0-10.2,4.25-13.18-4.25l-17,45.06s1.28,9.78,10.63,13.6l35.28,21.68s15.3,9.35,15.3,32.73,3,60.36,3,60.36S832,594.51,852,559.66c0,0-8.08-41.23-2.55-51.44,0,0,1.7-26.78,15.3-31.88L900,444s6.8-4.25,1.7-16.58l-11.9-29.33s-7.23,10.2-13.18,5.1l6.8,28.91-13.6,12.75s-12.75,6.38-19.13,6-13.6,2.55-13.6,2.55-3,17-16.58,15.3C820.53,468.69,794.6,467.41,808.63,449.14Z",
    transform: "translate(-133 -140.75)",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M808.63,447.44s-3.83,6-13.18.43S764,442.33,764,442.33l-22.1-10.2s1.7-36.56,6.8-38.26c0,0-10.2,4.25-13.18-4.25l-17,45.06s1.28,9.78,10.63,13.6L764.42,470s15.3,9.35,15.3,32.73,3,60.36,3,60.36S832,592.81,852,558c0,0-8.08-41.23-2.55-51.44,0,0,1.7-26.78,15.3-31.88L900,442.33s6.8-4.25,1.7-16.58l-11.9-29.33s-7.23,10.2-13.18,5.1l6.8,28.91-13.6,12.75s-12.75,6.38-19.13,6-13.6,2.55-13.6,2.55-3,17-16.58,15.3C820.53,467,794.6,465.71,808.63,447.44Z",
    transform: "translate(-133 -140.75)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M808.61,448.32l-.17.23Z",
    transform: "translate(-133 -140.75)",
    fill: "#d39999"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M900,443.19l-35.28,32.31c-13.6,5.1-15.3,31.88-15.3,31.88-5.53,10.2,2.55,51.44,2.55,51.44-20,34.86-69.29,5.1-69.29,5.1s-.1-1.22-.26-3.37c-.14-1.88-.33-4.48-.54-7.57-.28-4-.6-8.83-.9-14.07-.67-11.45-1.28-24.79-1.28-35.35,0-23.38-15.3-32.73-15.3-32.73L738,454.55l-8.82-5.42c-9.35-3.83-10.63-13.6-10.63-13.6l17-45.06c2.78,7.94,11.87,4.75,13.05,4.3-5,2.26-6.67,38.21-6.67,38.21l22.1,10.2s22.1,0,31.46,5.53c8,4.7,11.91,1.1,12.91-.09-13.44,18,12.17,19.21,12.17,19.21,13.6,1.7,16.58-15.3,16.58-15.3s7.23-3,13.6-2.55,19.13-6,19.13-6l13.6-12.75-6.8-28.91c6,5.1,13.18-5.1,13.18-5.1l11.9,29.33C906.83,438.93,900,443.19,900,443.19Z",
    transform: "translate(-133 -140.75)",
    fill: "#d39999"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M812,430.86a40.88,40.88,0,0,1-.41,8,20.82,20.82,0,0,0,24,12.53,15,15,0,0,1,1.51-11.16Z",
    transform: "translate(-133 -140.75)",
    opacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 697.95,
    cy: 288.62,
    r: 20.83,
    fill: "#f7bbc3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M830.61,417.52c-.18,2.11-.33,4.36.64,6.24a11.3,11.3,0,0,0,2,2.56l4.36,4.49a11.49,11.49,0,0,1,3.11,4.43c1.26,4.2-2.46,8.37-2.34,12.76a5.68,5.68,0,0,0,6.44,2.38,11,11,0,0,0,2.69-1.49l4.21-2.88c3.25-2.22,6.65-4.62,8.28-8.2,1.71-3.77,1.13-8.13,1.21-12.27a63.79,63.79,0,0,0,.11-7.57,22.3,22.3,0,0,0-2-6.94,25.21,25.21,0,0,0-8.9-10.83,17.65,17.65,0,0,0-13.56-2.63,9.15,9.15,0,0,1-2.3.41c-1.51,0-2.81-1-4.2-1.59a8.64,8.64,0,0,0-10.09,2.91c-.92,1.3-1.45,2.85-2.41,4.11-1.43,1.88-3.76,3.07-4.73,5.22s-.32,4.61-.53,6.93a19.08,19.08,0,0,1-1.89,5.95c2.36-.82,3.51-3.4,5-5.38a13.25,13.25,0,0,1,9.75-4.94c1.3-.06,3.71-.16,4.74.83C831.58,413.27,830.75,416,830.61,417.52Z",
    transform: "translate(-133 -140.75)",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M831,416.67c-.18,2.11-.33,4.36.64,6.24a11.3,11.3,0,0,0,2,2.56l4.36,4.49a11.49,11.49,0,0,1,3.11,4.43c1.26,4.2-2.46,8.37-2.34,12.76a5.68,5.68,0,0,0,6.44,2.38A11,11,0,0,0,848,448l4.21-2.88c3.25-2.22,6.65-4.62,8.28-8.2,1.71-3.77,1.13-8.13,1.21-12.27a63.79,63.79,0,0,0,.11-7.57,22.3,22.3,0,0,0-2-6.94,25.21,25.21,0,0,0-8.9-10.83,17.65,17.65,0,0,0-13.56-2.63,9.15,9.15,0,0,1-2.3.41c-1.51,0-2.81-1-4.2-1.59a8.64,8.64,0,0,0-10.09,2.91c-.92,1.3-1.45,2.85-2.41,4.11-1.43,1.88-3.76,3.07-4.73,5.22s-.32,4.61-.53,6.93a19.08,19.08,0,0,1-1.89,5.95c2.36-.82,3.51-3.4,5-5.38a13.25,13.25,0,0,1,9.75-4.94c1.3-.06,3.71-.16,4.74.83C832,412.42,831.17,415.12,831,416.67Z",
    transform: "translate(-133 -140.75)",
    fill: "#74585e"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M808.46,448.52c.12-.15.18-.24.18-.24Z",
    transform: "translate(-133 -140.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.43,403.8a5.47,5.47,0,0,1-3.79-1.42l.41,1.72A6,6,0,0,0,880.43,403.8Z",
    transform: "translate(-133 -140.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.08,450.73c-10.65,16.35,13.33,17.54,13.33,17.54a13.23,13.23,0,0,0,5.46-.39,14.21,14.21,0,0,1-3.33,0s-25.7-1.27-12.08-19.32A6.92,6.92,0,0,1,805.08,450.73Z",
    transform: "translate(-133 -140.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.59,450.41a17.93,17.93,0,0,0,5.11-.61,13.84,13.84,0,0,1-3,.19,27.88,27.88,0,0,0-7.87.79A25,25,0,0,1,848.59,450.41Z",
    transform: "translate(-133 -140.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.72,426.61l-11.9-29.33a21.73,21.73,0,0,1-1.54,1.87L899.6,427c5.1,12.33-1.7,16.58-1.7,16.58l-35.28,32.31c-13.6,5.1-15.3,31.88-15.3,31.88-5.53,10.2,2.55,51.44,2.55,51.44-5.36,9.35-12.83,14-20.9,15.92,8.87-1.51,17.19-6.18,23-16.35,0,0-8.08-41.23-2.55-51.44,0,0,1.7-26.78,15.3-31.88L900,443.19S906.83,438.93,901.72,426.61Z",
    transform: "translate(-133 -140.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.7,394.73a15.76,15.76,0,0,1-2.69.77c-4.66,4.09-6.23,37.91-6.23,37.91l22.1,10.2s22.1,0,31.46,5.53c4.58,2.71,7.83,2.66,10,1.91-2,.12-4.57-.41-7.83-2.33-9.35-5.53-31.46-5.53-31.46-5.53L741.89,433S743.59,396.43,748.7,394.73Z",
    transform: "translate(-133 -140.75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745,395.67c-3.23.42-7.67-.05-9.47-5.19l-1,2.65C737.31,397.08,742.4,396.36,745,395.67Z",
    transform: "translate(-133 -140.75)"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M781,538.9c-.67-11.45-1.28-24.79-1.28-35.35,0-23.38-15.3-32.73-15.3-32.73L738,454.55c15.4,4,35.89,10.89,37.73,19,3,13.18,8.5,14.45,6.38,37A254.89,254.89,0,0,0,781,538.9Z",
    transform: "translate(-133 -140.75)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M785,571.35s3.83,11.9-6.8,19.55",
    transform: "translate(-133 -140.75)",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M844.55,571.35s1.28,8.93,6.38,12.33",
    transform: "translate(-133 -140.75)",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M789.93,742.44s-20.4,9.35-37.83,11.9c-8.84,1.29-12.1-1.35-12.61-4.15-.58,3.27,2,7.41,12.61,5.85,17.43-2.55,37.83-11.9,37.83-11.9a36,36,0,0,0,.14-4.25C790,741.45,789.93,742.44,789.93,742.44Z",
    transform: "translate(-133 -140.75)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M874.94,751.37c-16.58-1.7-28.91-14.88-28.91-14.88s.63-10.06,3.65-16.49c-3.39,6.35-4.08,17.34-4.08,17.34s12.33,13.18,28.91,14.88c8.47.87,12.17-1.48,13.08-4C886.2,750.39,882.44,752.14,874.94,751.37Z",
    transform: "translate(-133 -140.75)",
    opacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 505.25,
    y: 331.9,
    width: 106.64,
    height: 71.09,
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1003,653.38s-18.74-63.63,3.51-110.45a100.49,100.49,0,0,0,8.13-63,169,169,0,0,0-8.93-29.59",
    transform: "translate(-133 -140.75)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.6,420.69c0,7.8-14.12,30.41-14.12,30.41s-14.12-22.61-14.12-30.41a14.12,14.12,0,1,1,28.24,0Z",
    transform: "translate(-133 -140.75)",
    fill: "#00b27d"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.94,463.89c-4.24,6.55-28.38,17.85-28.38,17.85s.44-26.65,4.68-33.2a14.12,14.12,0,0,1,23.7,15.35Z",
    transform: "translate(-133 -140.75)",
    fill: "#00b27d"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.92,537.69c-7,3.51-33.51,1.09-33.51,1.09s13.83-22.79,20.8-26.3a14.12,14.12,0,1,1,12.71,25.21Z",
    transform: "translate(-133 -140.75)",
    fill: "#00b27d"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.57,593.37c-6.27,4.64-32.84,6.73-32.84,6.73s9.78-24.8,16.05-29.43a14.12,14.12,0,1,1,16.79,22.7Z",
    transform: "translate(-133 -140.75)",
    fill: "#00b27d"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M984.91,483.25c5.59,5.43,31.65,11.06,31.65,11.06s-6.38-25.88-12-31.32a14.12,14.12,0,0,0-19.68,20.25Z",
    transform: "translate(-133 -140.75)",
    fill: "#00b27d"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M970.13,548.56c7,3.51,33.51,1.09,33.51,1.09s-13.83-22.79-20.8-26.3a14.12,14.12,0,0,0-12.71,25.21Z",
    transform: "translate(-133 -140.75)",
    fill: "#00b27d"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M964.47,614c6.27,4.64,32.84,6.73,32.84,6.73s-9.78-24.8-16.05-29.43A14.12,14.12,0,0,0,964.47,614Z",
    transform: "translate(-133 -140.75)",
    fill: "#00b27d"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M934.16,618.22s-11.78-40,2.21-69.44a63.18,63.18,0,0,0,5.11-39.63,106.25,106.25,0,0,0-5.61-18.6",
    transform: "translate(-133 -140.75)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M944.57,471.94c0,4.9-8.88,19.12-8.88,19.12s-8.88-14.22-8.88-19.12a8.88,8.88,0,0,1,17.75,0Z",
    transform: "translate(-133 -140.75)",
    fill: "#00b27d"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M959.25,499.09c-2.66,4.11-17.84,11.22-17.84,11.22s.28-16.76,2.94-20.87a8.88,8.88,0,1,1,14.9,9.65Z",
    transform: "translate(-133 -140.75)",
    fill: "#00b27d"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M958.6,545.49c-4.38,2.21-21.07.68-21.07.68s8.7-14.33,13.07-16.53a8.88,8.88,0,0,1,8,15.85Z",
    transform: "translate(-133 -140.75)",
    fill: "#00b27d"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M950.21,580.49c-3.94,2.92-20.65,4.23-20.65,4.23s6.15-15.59,10.09-18.5a8.88,8.88,0,0,1,10.56,14.27Z",
    transform: "translate(-133 -140.75)",
    fill: "#00b27d"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M922.77,511.26c3.52,3.42,19.9,7,19.9,7s-4-16.27-7.53-19.69a8.88,8.88,0,1,0-12.37,12.73Z",
    transform: "translate(-133 -140.75)",
    fill: "#00b27d"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M913.47,552.32c4.38,2.21,21.07.68,21.07.68s-8.7-14.33-13.07-16.53a8.88,8.88,0,0,0-8,15.85Z",
    transform: "translate(-133 -140.75)",
    fill: "#00b27d"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M909.92,593.46c3.94,2.92,20.65,4.23,20.65,4.23s-6.15-15.59-10.09-18.5a8.88,8.88,0,1,0-10.56,14.27Z",
    transform: "translate(-133 -140.75)",
    fill: "#00b27d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawImageUpload);
export default __webpack_public_path__ + "static/media/undraw-image-upload.ea323928ad1cba2b90538c4e5e1eb6dd.svg";
export { ForwardRef as ReactComponent };